import { useState } from "react";

export default function NewsletterSection() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem("website_alt") as HTMLInputElement)?.value.trim();
    if (honeypot) {
      setStatus("success");
      setEmail("");
      return;
    }

    if (!email.trim()) {
      setErrorMsg("请输入您的邮箱地址");
      return;
    }

    try {
      const formData = new FormData(form);
      const res = await fetch(
        "https://readdy.ai/api/form/d9sqt8l8o1vn02ekuklg",
        {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
        }
      );

      const responseText = await res.text();
      let parsed: Record<string, unknown> = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // ignore parse error
      }

      if (res.ok && (parsed as { code?: string })?.code === "OK") {
        setStatus("success");
        setEmail("");
        setErrorMsg("");
      } else {
        const serverMsg =
          (parsed as { meta?: { message?: string } })?.meta?.message ||
          (parsed as { message?: string })?.message ||
          (parsed as { meta?: { detail?: string } })?.meta?.detail ||
          responseText;
        if (serverMsg.includes("spam")) {
          setStatus("error");
          setErrorMsg("提交失败，请稍后再试");
        } else {
          setStatus("error");
          setErrorMsg(serverMsg || "订阅失败，请稍后再试");
        }
      }
    } catch {
      setStatus("error");
      setErrorMsg("网络错误，请检查连接后重试");
    }
  };

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100/70">
      <div className="max-w-2xl mx-auto text-center">
        <i className="ri-mail-send-line text-3xl md:text-4xl text-primary-500"></i>
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mt-4 mb-2">
          订阅我们的Newsletter
        </h2>
        <p className="text-sm text-foreground-500 mb-6">
          每周精选热门小说推荐，不错过任何一本好书
        </p>

        {status === "success" ? (
          <div className="py-4 px-6 bg-accent-100 text-accent-800 rounded-lg text-sm">
            订阅成功！感谢你的关注，我们会定期为你推送精选内容。
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            data-readdy-form=""
            className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
          >
            <input
              type="text"
              name="website_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="website-alt-field"
            />
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setErrorMsg("");
              }}
              placeholder="输入你的邮箱地址"
              className="flex-1 w-full px-4 py-3 rounded-full border border-background-300 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
              required
            />
            <button
              type="submit"
              className="px-6 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full text-sm font-medium hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
            >
              订阅
            </button>
            {errorMsg && (
              <p className="text-xs text-red-500 mt-1 w-full text-left sm:text-center">
                {errorMsg}
              </p>
            )}
          </form>
        )}
      </div>
    </section>
  );
}